// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
}

/* Wide screens: list on the left, map on the right, both as tall as the page */
.buildings {
  display: flex;
  flex-direction: column;
  gap: 12px;
  height: 100%;
  min-height: 0;
}
.buildings--wide {
  display: grid;
  grid-template-columns: minmax(380px, 480px) minmax(0, 1fr);
  gap: 20px;
}

.buildings__list-panel {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  gap: 10px;
}

.buildings__search {
  --background: var(--ion-background-color, #fff);
  --border-radius: 10px;
  --box-shadow: none;
  padding: 0;
  border: 1px solid rgba(var(--ion-color-medium-rgb), 0.25);
  border-radius: 10px;
  min-height: 44px;
  flex-shrink: 0;
}

/* The cards scroll, the search stays on top */
.buildings__list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  /* room for the hover lift and shadow of the cards */
  padding: 2px 2px 12px;
  margin: -2px;
}

.buildings__empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 40px 16px;
  border: 1px dashed rgba(var(--ion-color-medium-rgb), 0.35);
  border-radius: 14px;
  background: var(--ion-background-color, #fff);
  color: var(--ion-color-medium);
  text-align: center;
}
.buildings__empty p {
  margin: 0;
  max-width: 280px;
  font-size: 14px;
}

.buildings__empty-icon {
  display: grid;
  place-items: center;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: rgba(var(--ion-color-primary-rgb), 0.1);
  color: var(--ion-color-primary);
}
.buildings__empty-icon ion-icon {
  font-size: 28px;
}

.buildings__empty-add {
  --border-radius: 10px;
  --box-shadow: none;
  margin-top: 6px;
  text-transform: none;
  font-weight: 600;
}

.buildings__map-panel {
  display: none;
  min-height: 0;
  border: 1px solid rgba(var(--ion-color-medium-rgb), 0.18);
  border-radius: 14px;
  overflow: hidden;
  background: var(--ion-background-color, #fff);
}

.buildings__map {
  width: 100%;
  height: 100%;
}

/* Wide screens: the map is always visible */
.buildings--wide .buildings__map-panel {
  display: block;
}

/* Phones with the map selected: map instead of the list */
.buildings--show-map:not(.buildings--wide) .buildings__list-panel {
  display: none;
}
.buildings--show-map:not(.buildings--wide) .buildings__map-panel {
  display: block;
  flex: 1;
}

/* List / Map switch (phones only) */
.view-switch {
  display: flex;
  flex-shrink: 0;
  gap: 4px;
  padding: 4px;
  border: 1px solid rgba(var(--ion-color-medium-rgb), 0.25);
  border-radius: 10px;
  background: var(--ion-background-color, #fff);
}

.view-switch__option {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  flex: 1;
  height: 36px;
  border: 0;
  border-radius: 7px;
  background: transparent;
  color: var(--ion-color-medium);
  font: inherit;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease;
}
.view-switch__option ion-icon {
  font-size: 18px;
}
.view-switch__option:hover {
  color: var(--ion-color-primary);
  background: rgba(var(--ion-color-primary-rgb), 0.06);
}
.view-switch__option--active, .view-switch__option--active:hover {
  background: var(--ion-color-primary);
  color: var(--ion-color-primary-contrast);
}`, "",{"version":3,"sources":["webpack://./src/components/general components/building-list/building-list.component.scss","webpack://./src/components/general%20components/building-list/building-list.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;ACCF;;ADEA,+EAAA;AACA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,YAAA;EACA,aAAA;ACCF;ADCE;EACE,aAAA;EACA,0DAAA;EACA,SAAA;ACCJ;;ADGA;EACE,aAAA;EACA,sBAAA;EACA,OAAA;EACA,aAAA;EACA,SAAA;ACAF;;ADGA;EACE,+CAAA;EACA,qBAAA;EACA,kBAAA;EACA,UAAA;EACA,yDAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;ACAF;;ADGA,8CAAA;AACA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,OAAA;EACA,aAAA;EACA,gBAAA;EACA,oDAAA;EACA,qBAAA;EACA,YAAA;ACAF;;ADGA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,0DAAA;EACA,mBAAA;EACA,6CAAA;EACA,8BAAA;EACA,kBAAA;ACAF;ADEE;EACE,SAAA;EACA,gBAAA;EACA,eAAA;ACAJ;;ADIA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mDAAA;EACA,+BAAA;ACDF;ADGE;EACE,eAAA;ACDJ;;ADKA;EACE,qBAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;EACA,gBAAA;ACFF;;ADKA;EACE,aAAA;EACA,aAAA;EACA,yDAAA;EACA,mBAAA;EACA,gBAAA;EACA,6CAAA;ACFF;;ADKA;EACE,WAAA;EACA,YAAA;ACFF;;ADKA,4CAAA;AACA;EACE,cAAA;ACFF;;ADKA,0DAAA;AAEE;EACE,aAAA;ACHJ;ADME;EACE,cAAA;EACA,OAAA;ACJJ;;ADQA,oCAAA;AACA;EACE,aAAA;EACA,cAAA;EACA,QAAA;EACA,YAAA;EACA,yDAAA;EACA,mBAAA;EACA,6CAAA;ACLF;;ADQA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,OAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;EACA,uBAAA;EACA,8BAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yDAAA;ACLF;ADOE;EACE,eAAA;ACLJ;ADQE;EACE,+BAAA;EACA,oDAAA;ACNJ;ADSE;EAEE,oCAAA;EACA,wCAAA;ACRJ","sourcesContent":[":host {\n  display: block;\n}\n\n/* Wide screens: list on the left, map on the right, both as tall as the page */\n.buildings {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  height: 100%;\n  min-height: 0;\n\n  &--wide {\n    display: grid;\n    grid-template-columns: minmax(380px, 480px) minmax(0, 1fr);\n    gap: 20px;\n  }\n}\n\n.buildings__list-panel {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-height: 0;\n  gap: 10px;\n}\n\n.buildings__search {\n  --background: var(--ion-background-color, #fff);\n  --border-radius: 10px;\n  --box-shadow: none;\n  padding: 0;\n  border: 1px solid rgba(var(--ion-color-medium-rgb), 0.25);\n  border-radius: 10px;\n  min-height: 44px;\n  flex-shrink: 0;\n}\n\n/* The cards scroll, the search stays on top */\n.buildings__list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  /* room for the hover lift and shadow of the cards */\n  padding: 2px 2px 12px;\n  margin: -2px;\n}\n\n.buildings__empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n  padding: 40px 16px;\n  border: 1px dashed rgba(var(--ion-color-medium-rgb), 0.35);\n  border-radius: 14px;\n  background: var(--ion-background-color, #fff);\n  color: var(--ion-color-medium);\n  text-align: center;\n\n  p {\n    margin: 0;\n    max-width: 280px;\n    font-size: 14px;\n  }\n}\n\n.buildings__empty-icon {\n  display: grid;\n  place-items: center;\n  width: 56px;\n  height: 56px;\n  border-radius: 50%;\n  background: rgba(var(--ion-color-primary-rgb), 0.1);\n  color: var(--ion-color-primary);\n\n  ion-icon {\n    font-size: 28px;\n  }\n}\n\n.buildings__empty-add {\n  --border-radius: 10px;\n  --box-shadow: none;\n  margin-top: 6px;\n  text-transform: none;\n  font-weight: 600;\n}\n\n.buildings__map-panel {\n  display: none;\n  min-height: 0;\n  border: 1px solid rgba(var(--ion-color-medium-rgb), 0.18);\n  border-radius: 14px;\n  overflow: hidden;\n  background: var(--ion-background-color, #fff);\n}\n\n.buildings__map {\n  width: 100%;\n  height: 100%;\n}\n\n/* Wide screens: the map is always visible */\n.buildings--wide .buildings__map-panel {\n  display: block;\n}\n\n/* Phones with the map selected: map instead of the list */\n.buildings--show-map:not(.buildings--wide) {\n  .buildings__list-panel {\n    display: none;\n  }\n\n  .buildings__map-panel {\n    display: block;\n    flex: 1;\n  }\n}\n\n/* List / Map switch (phones only) */\n.view-switch {\n  display: flex;\n  flex-shrink: 0;\n  gap: 4px;\n  padding: 4px;\n  border: 1px solid rgba(var(--ion-color-medium-rgb), 0.25);\n  border-radius: 10px;\n  background: var(--ion-background-color, #fff);\n}\n\n.view-switch__option {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  flex: 1;\n  height: 36px;\n  border: 0;\n  border-radius: 7px;\n  background: transparent;\n  color: var(--ion-color-medium);\n  font: inherit;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 0.15s ease, color 0.15s ease;\n\n  ion-icon {\n    font-size: 18px;\n  }\n\n  &:hover {\n    color: var(--ion-color-primary);\n    background: rgba(var(--ion-color-primary-rgb), 0.06);\n  }\n\n  &--active,\n  &--active:hover {\n    background: var(--ion-color-primary);\n    color: var(--ion-color-primary-contrast);\n  }\n}\n",":host {\n  display: block;\n}\n\n/* Wide screens: list on the left, map on the right, both as tall as the page */\n.buildings {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  height: 100%;\n  min-height: 0;\n}\n.buildings--wide {\n  display: grid;\n  grid-template-columns: minmax(380px, 480px) minmax(0, 1fr);\n  gap: 20px;\n}\n\n.buildings__list-panel {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-height: 0;\n  gap: 10px;\n}\n\n.buildings__search {\n  --background: var(--ion-background-color, #fff);\n  --border-radius: 10px;\n  --box-shadow: none;\n  padding: 0;\n  border: 1px solid rgba(var(--ion-color-medium-rgb), 0.25);\n  border-radius: 10px;\n  min-height: 44px;\n  flex-shrink: 0;\n}\n\n/* The cards scroll, the search stays on top */\n.buildings__list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  /* room for the hover lift and shadow of the cards */\n  padding: 2px 2px 12px;\n  margin: -2px;\n}\n\n.buildings__empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n  padding: 40px 16px;\n  border: 1px dashed rgba(var(--ion-color-medium-rgb), 0.35);\n  border-radius: 14px;\n  background: var(--ion-background-color, #fff);\n  color: var(--ion-color-medium);\n  text-align: center;\n}\n.buildings__empty p {\n  margin: 0;\n  max-width: 280px;\n  font-size: 14px;\n}\n\n.buildings__empty-icon {\n  display: grid;\n  place-items: center;\n  width: 56px;\n  height: 56px;\n  border-radius: 50%;\n  background: rgba(var(--ion-color-primary-rgb), 0.1);\n  color: var(--ion-color-primary);\n}\n.buildings__empty-icon ion-icon {\n  font-size: 28px;\n}\n\n.buildings__empty-add {\n  --border-radius: 10px;\n  --box-shadow: none;\n  margin-top: 6px;\n  text-transform: none;\n  font-weight: 600;\n}\n\n.buildings__map-panel {\n  display: none;\n  min-height: 0;\n  border: 1px solid rgba(var(--ion-color-medium-rgb), 0.18);\n  border-radius: 14px;\n  overflow: hidden;\n  background: var(--ion-background-color, #fff);\n}\n\n.buildings__map {\n  width: 100%;\n  height: 100%;\n}\n\n/* Wide screens: the map is always visible */\n.buildings--wide .buildings__map-panel {\n  display: block;\n}\n\n/* Phones with the map selected: map instead of the list */\n.buildings--show-map:not(.buildings--wide) .buildings__list-panel {\n  display: none;\n}\n.buildings--show-map:not(.buildings--wide) .buildings__map-panel {\n  display: block;\n  flex: 1;\n}\n\n/* List / Map switch (phones only) */\n.view-switch {\n  display: flex;\n  flex-shrink: 0;\n  gap: 4px;\n  padding: 4px;\n  border: 1px solid rgba(var(--ion-color-medium-rgb), 0.25);\n  border-radius: 10px;\n  background: var(--ion-background-color, #fff);\n}\n\n.view-switch__option {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  flex: 1;\n  height: 36px;\n  border: 0;\n  border-radius: 7px;\n  background: transparent;\n  color: var(--ion-color-medium);\n  font: inherit;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 0.15s ease, color 0.15s ease;\n}\n.view-switch__option ion-icon {\n  font-size: 18px;\n}\n.view-switch__option:hover {\n  color: var(--ion-color-primary);\n  background: rgba(var(--ion-color-primary-rgb), 0.06);\n}\n.view-switch__option--active, .view-switch__option--active:hover {\n  background: var(--ion-color-primary);\n  color: var(--ion-color-primary-contrast);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
